<template>
  <div class="text-sm">
    <p class="mt-6"><b>2024.12.26</b> - Небольшие изменения баланса и исправления ИИ</p>
    <ul class="ml-5 pb-4 list-outside list-disc">
      <li>
        Баланс
        <ul>
          <li>- Маска дьявола</li>
          <ul>
            <li class="pl-4">* стоимость ОД: <code>10</code> --> <code>40</code></li>
            <li class="pl-4">
              * стоимость МС: <code>30 + Уровень*3</code> -->
              <code>30 + Уровень*5</code>
            </li>
            <li class="pl-4">* дальность эффекта: <code>1 + Уровень/5</code> --> <code>2</code></li>
          </ul>
          <li>
            - Мощность Отравленное оружие: <code>20 + Уровень*(Об/15)</code> -->
            <code>20 + Уровень*(Об/5)</code>
          </li>
        </ul>
      </li>
      <li>
        ИИ
        <ul>
          <li>- Исправлен баг, при котором Маска дьявола мог быть применён без врагов в радиусе</li>
          <li>- Для лечения герои теперь будут нацеливаться только на героев в PvP</li>
          <li>- Для баффов юниты теперь начинают с ближайших не-забаффанных союзников</li>
          <li>- Аналогично, Наложение швов теперь нацелится на ближайшего союзника, которому это нужно</li>
          <li>- Юниты больше не будут использовать Прыжок/Телепортация в страхе</li>
        </ul>
      </li>
      <li>Опции на Куклы вуду теперь могут наносить урон</li>
    </ul>
  </div>
</template>
